<template>
  <v-dialog
    height="800"
    width="500px"
    max-width="100%"
    v-model="opened"
    persistent
  >
    <iframe
      src="https://app.livechatai.com/aibot-iframe/clrj8v1870001l80fs50fwpx4"
      style="border: 1px solid #eaeaea"
      width="100%"
      height="480"
      frameborder="0"
    ></iframe>
    <v-card-actions>
      <v-spacer />
      <v-btn color="primary" text @click="closeDialog()">Fechar</v-btn>
    </v-card-actions>
  </v-dialog>
</template>

<script>
export default {
  props: {
    opened: {
      type: Boolean,
    },
  },
  data() {
    return {
      loading: false,
    };
  },
  methods: {
    closeDialog() {
      this.$emit("onCloseChatDialog");
    },
  },
};
</script>
